import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c6f57c28"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "campaign-action" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = {
  key: 2,
  class: "spinner centered"
}
const _hoisted_5 = ["data-address"]
const _hoisted_6 = { key: 0 }
const _hoisted_7 = {
  key: 0,
  class: "campaign-action-eligibility"
}
const _hoisted_8 = { class: "campaign-action-eligibility" }
const _hoisted_9 = { class: "campaign-action-quantity" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Mint Quantity", -1))
const _hoisted_11 = { key: 0 }
const _hoisted_12 = {
  key: 1,
  class: "spinner centered"
}
const _hoisted_13 = ["data-address"]
const _hoisted_14 = { class: "campaign-action-transaction" }
const _hoisted_15 = ["href"]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "View tx on Etherscan", -1))
const _hoisted_17 = ["href"]
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "View Token on OpenSea", -1))
const _hoisted_19 = ["data-network", "data-fallback-provider"]

import { BigNumber } from '@ethersproject/bignumber';
import { ArrowTopRightOnSquareIcon } from '@heroicons/vue/20/solid';
import dayjs from 'dayjs/esm/index';
import calendar from 'dayjs/esm/plugin/calendar';
import relativeTime from 'dayjs/esm/plugin/relativeTime';
import { capitalize, computed, onBeforeMount, Ref, ref, watch } from 'vue';
import { ETHEREUM_NETWORK_NAMES, MAX_MINT_FREE, MAX_MINT_PAYABLE, NETWORK_ID } from '@/common/constants';
import Alert from '@/components/Alert.vue';
import DelegationPicker from '@/components/DelegationPicker.vue';
import { pluralize } from '@/lib/claimUtil';
import { useClaimStore } from '@/store/claimStore';

interface ActionProps {
  error: any;
  numberToMint: string;
  mintStatus: Ref<'error' | 'loading' | 'idle' | 'success'>;
  txLink: string;
  mintedTokenId?: BigNumber;
  mint: () => void;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'Action',
  props: {
    error: null,
    numberToMint: null,
    mintStatus: null,
    txLink: null,
    mintedTokenId: null,
    mint: { type: Function }
  },
  emits: ['numberToMintChanged'],
  setup(__props: any, { emit }) {

const props = __props as {
  error: any;
  numberToMint: string;
  mintStatus: Ref<'error' | 'loading' | 'idle' | 'success'>;
  txLink: string;
  mintedTokenId?: BigNumber;
  mint: () => void;
};

dayjs.extend(calendar);
dayjs.extend(relativeTime);

const CalendarFormat = {
  sameDay: '[today,] MMM D YYYY[, at] h:mm A', // today, Feb 2 2023, at 2:30 PM
  nextDay: '[tomorrow,] MMM D YYYY[, at] h:mm A', // tomorrow, Feb 3 2023, at 2:30 PM
  nextWeek: 'dddd[,] MMM D YYYY[, at] h:mm A', // Sunday, Feb 5 2023, at 2:30 PM
  lastDay: '[yesterday,] MMM D YYYY[, at] h:mm A', // yesterday, Feb 1 2023, at 2:30 PM
  lastWeek: '[last] dddd, MMM D YYYY[, at] h:mm A', // last Monday at 2:30 PM
  sameElse: 'MMM D YYYY [at] h:mm A' // Mar 1 2023 at 2:30 PM
};



const store = useClaimStore();

const _numberToMint = ref('0');
/**
 * in short
 * - if there's an explicit wallet limit or allowlist, allow them to mint as much as they want per tx.
 * - otherwise, cap at artificial limit
 */
const maxClaimablePerTX = computed(() => {
  if (store.claimableQuantity < Infinity && (store.hasAllowlist || store.hasWalletLimit)) {
    return store.claimableQuantity;
  } else {
    return store.isPayable ? MAX_MINT_PAYABLE : MAX_MINT_FREE;
  }
});

const mintButtonLabel = computed(() => {
  const suffix = parseInt(_numberToMint.value) > 1 ? 's' : '';
  if (store.cost.eq(0)) {
    return 'Claim Token' + suffix;
  } else {
    return 'Buy Token' + suffix;
  }
});

const wrongNetworkText = computed(() => {
  const networkName = ETHEREUM_NETWORK_NAMES[store.targetNetwork];
  const capitalized = capitalize(networkName.toLowerCase());
  return `Please switch to the ${capitalized} network to continue.`;
});

onBeforeMount(() => {
  _numberToMint.value = props.numberToMint;
});



watch(_numberToMint, (value) => {
  emit('numberToMintChanged', value);
});

function getCalendarString (dayjsDate: dayjs.Dayjs | null) {
  return dayjsDate?.calendar(null, CalendarFormat) || '';
}

const claimStartDate = computed(() => {
  if (store.startDate) {
    return dayjs(store.startDate);
  }
  return null;
});

const claimEndDate = computed(() => {
  if (store.endDate) {
    return dayjs(store.endDate);
  }
  return null;
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (Boolean(__props.error))
      ? (_openBlock(), _createBlock(Alert, {
          key: 0,
          type: "error"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", {
              innerHTML: __props.error.error
            }, null, 8, _hoisted_2)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (Boolean(_unref(store).delegationError))
      ? (_openBlock(), _createBlock(Alert, {
          key: 1,
          type: "error"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", {
              innerHTML: _unref(store).delegationError
            }, null, 8, _hoisted_3)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_unref(store).isLoadingWeb3State || _unref(store).isDelegationLoading)
      ? (_openBlock(), _createElementBlock("i", _hoisted_4))
      : (_unref(store).status === 'not-started')
        ? (_openBlock(), _createBlock(Alert, {
            key: 3,
            type: "info"
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", null, "Mark your calendars — This claim starts " + _toDisplayString(getCalendarString(_unref(claimStartDate))) + _toDisplayString(_unref(store)?.endDate ? ` and ends ${getCalendarString(_unref(claimEndDate))}`: '') + ".", 1),
              _createElementVNode("div", {
                id: "restricted-token",
                "data-widget": "m-restricted-token",
                "data-address": _unref(store).creatorContractAddress
              }, null, 8, _hoisted_5)
            ]),
            _: 1
          }))
        : (_unref(store).status === 'ended')
          ? (_openBlock(), _createBlock(Alert, {
              key: 4,
              type: "info"
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", null, " This claim ended" + _toDisplayString(_unref(claimEndDate) && ` ${_unref(claimEndDate)!.fromNow()}`) + ". ", 1)
              ]),
              _: 1
            }))
          : (_unref(store).status === 'active')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                (_unref(store).isSoldOut)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      _createVNode(Alert, { type: "info" }, {
                        default: _withCtx(() => [
                          _createTextVNode("Sold out! Try picking one up on secondary markets.")
                        ]),
                        _: 1
                      })
                    ]))
                  : (_unref(store).isConnected)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        (!_unref(store).isChainCorrect)
                          ? (_openBlock(), _createBlock(Alert, {
                              key: 0,
                              type: "warn"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_unref(wrongNetworkText)), 1)
                              ]),
                              _: 1
                            }))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              (_unref(store).claimableQuantity === 0)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                                    _createVNode(Alert, { type: "info" }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_unref(store).tokensMintedByWallet === 0 || _unref(store).tokensMintedByWallet === null
                        ? 'Sorry, there are no tokens for you to claim.'
                        : 'You\'ve claimed all your tokens.'), 1)
                                      ]),
                                      _: 1
                                    }),
                                    (_unref(store).eligibleVaultWallets && _unref(store).walletAddress)
                                      ? (_openBlock(), _createBlock(DelegationPicker, {
                                          key: 0,
                                          class: "campaign-action-delegation-picker",
                                          selectedWallet: _unref(store).mintForWallet ?? _unref(store).walletAddress,
                                          delegatedWallet: _unref(store).walletAddress,
                                          vaultWallets: _unref(store).eligibleVaultWallets,
                                          onWalletSelect: _cache[0] || (_cache[0] = ($event: any) => (_unref(store).setMintForWallet($event)))
                                        }, null, 8, ["selectedWallet", "delegatedWallet", "vaultWallets"]))
                                      : _createCommentVNode("", true)
                                  ]))
                                : _createCommentVNode("", true),
                              (_unref(store).claimableQuantity > 0)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                    _createElementVNode("div", _hoisted_8, [
                                      _createVNode(Alert, { type: "info" }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_unref(store).walletRestriction === 'no-limit'
                      ? `You can claim as many as you want. Up to ${_unref(maxClaimablePerTX)} per transaction.`
                      : `You can claim up to ${ _unref(maxClaimablePerTX) } ${_unref(pluralize)(_unref(maxClaimablePerTX), 'token')}`), 1)
                                        ]),
                                        _: 1
                                      }),
                                      (_unref(store).eligibleVaultWallets && _unref(store).walletAddress)
                                        ? (_openBlock(), _createBlock(DelegationPicker, {
                                            key: 0,
                                            class: "campaign-action-delegation-picker",
                                            selectedWallet: _unref(store).mintForWallet ?? _unref(store).walletAddress,
                                            delegatedWallet: _unref(store).walletAddress!,
                                            vaultWallets: _unref(store).eligibleVaultWallets,
                                            onWalletSelect: _cache[1] || (_cache[1] = ($event: any) => (_unref(store).setMintForWallet($event)))
                                          }, null, 8, ["selectedWallet", "delegatedWallet", "vaultWallets"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _createElementVNode("div", _hoisted_9, [
                                      _withDirectives(_createElementVNode("select", {
                                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_numberToMint).value = $event))
                                      }, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(maxClaimablePerTX), (index) => {
                                          return (_openBlock(), _createElementBlock("option", { key: index }, _toDisplayString(index), 1))
                                        }), 128))
                                      ], 512), [
                                        [_vModelSelect, _numberToMint.value]
                                      ]),
                                      _hoisted_10
                                    ]),
                                    _createElementVNode("button", {
                                      onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (__props.mint && __props.mint(...args))),
                                      class: "campaign-action-button"
                                    }, [
                                      (__props.mintStatus.value !== 'loading')
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_unref(mintButtonLabel)), 1))
                                        : _createCommentVNode("", true),
                                      (__props.mintStatus.value == 'loading')
                                        ? (_openBlock(), _createElementBlock("i", _hoisted_12))
                                        : _createCommentVNode("", true)
                                    ])
                                  ], 64))
                                : _createCommentVNode("", true),
                              _createElementVNode("div", {
                                id: "restricted-token",
                                class: "manifold-scheme-dark",
                                "data-widget": "m-restricted-token",
                                "data-address": _unref(store).creatorContractAddress
                              }, null, 8, _hoisted_13),
                              _createElementVNode("div", _hoisted_14, [
                                (__props.txLink)
                                  ? (_openBlock(), _createElementBlock("a", {
                                      key: 0,
                                      href: `https://etherscan.io/tx/${__props.txLink}`,
                                      target: "_blank"
                                    }, [
                                      _hoisted_16,
                                      _createVNode(_unref(ArrowTopRightOnSquareIcon), { class: "link-icon" })
                                    ], 8, _hoisted_15))
                                  : _createCommentVNode("", true),
                                (__props.mintedTokenId)
                                  ? (_openBlock(), _createElementBlock("a", {
                                      key: 1,
                                      href: `https://opensea.io/assets/${_unref(store).creatorContractAddress}/${__props.mintedTokenId}`,
                                      target: "_blank"
                                    }, [
                                      _hoisted_18,
                                      _createVNode(_unref(ArrowTopRightOnSquareIcon), { class: "link-icon" })
                                    ], 8, _hoisted_17))
                                  : _createCommentVNode("", true)
                              ])
                            ], 64))
                      ], 64))
                    : (_openBlock(), _createElementBlock("div", {
                        key: 2,
                        "data-widget": "m-connect",
                        "data-grant-type": "signature",
                        "data-client-id": "02865a407876e82f4389f70992c25323e967504d37663290f11fd49e79b607e0",
                        "data-app-name": "Manifold Notifications",
                        "data-delay-auth": "always",
                        "data-network": _unref(NETWORK_ID),
                        "data-fallback-provider": _unref(store).fallbackProvider,
                        "data-multi": "true",
                        "data-message": "Please sign this message to confirm your wallet address",
                        "data-test": "connect-widget"
                      }, null, 8, _hoisted_19))
              ], 64))
            : _createCommentVNode("", true)
  ]))
}
}

})